import { Link } from 'gatsby';
import styled from 'styled-components';

export const MainContainer = styled.div`
  min-height: 6.25rem;
  background-color: #ebebeb;
  top: 10rem;
  position: absolute;
  width: 100%;
  z-index: 100;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  @media (min-width: 36rem) {
    display: none !important;
  }
`;

export const MenuLabel = styled.span`
  font-size: 0.75rem;
  height: 6.25rem;
  background-color: #ebebeb;
  padding: 2.5rem 1rem;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  border: none;
  outline: none;
  cursor: pointer;

  &:after {
    content: '';
    margin-left: ${({ isArabic }) => (isArabic ? '0' : '1rem')};
    margin-right: ${({ isArabic }) => (isArabic ? '1rem' : '0')};
    display: inline-block;
    margin-bottom: 3px;
    width: 0;
    height: 0;
    border: solid #000;
    border-width: 0 2px 2px 0;
    padding: 3px;
    animation-name: ${({ isOpen }) => (isOpen ? 'arrow-up' : 'arrow-down')};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
  }

  @keyframes arrow-up {
    from {
      transform: rotate(45deg);
    }
    to {
      transform: rotate(-135deg);
    }
  }

  @keyframes arrow-down {
    from {
      transform: rotate(-135deg);
    }
    to {
      transform: rotate(45deg);
    }
  }
`;

export const MenuLink = styled(Link)`
  font-size: 0.75rem;
  height: 3.25rem;
  background-color: #ebebeb;
  padding: 1rem 1rem;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
`;
